export { default } from './BaseWizard';
export { default as reducer } from './BaseWizard.slice';

import * as actions from './BaseWizard.slice';
export { actions };
